import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const promotionState = {
  cashSharePromoList: null,
  promotionLists: null,
  promotionCaptionLists: null,
  voucherNotUseLists: null,
  promotionUI: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const promotionSlice = createSlice({
  name: "promotion",
  initialState: promotionState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },

    promotionListsFetched: (state, action) => {
      state.listLoading = false;
      state.promotionLists = action.payload.data ?? {};
    },
    promotionDetailFetched: (state, action) => {
      state.listLoading = false;
      state.promotionUI = action.payload.data ?? {};
    },
    promotionUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.promotionUI = action.payload.data ?? {};
    },
    clearPromotionUI: (state) => {
      state.promotionUI = null;
    },
    promotionCaptionListsFetched: (state, action) => {
      state.actionsLoading = false;
      state.promotionCaptionLists = action.payload.data ?? {};
    },
    voucherNotUseListsFetched: (state, action) => {
      state.actionsLoading = false;
      state.voucherNotUseLists = action.payload.data ?? {};
    },
    cashSharePromoListFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashSharePromoList = action.payload.data;
    },
    clearVoucherList: (state, action) => {
      state.voucherNotUseLists = null;
    },
    clearCaptionList: (state, action) => {
      state.promotionCaptionLists = null;
    },
    promotionManaged: (state) => {
      state.actionsLoading = false;
    },
  },
});
